module.exports = __webpack_public_path__ + "assets/images/background.deecabd.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/background.svg
// module id = 251
// module chunks = 1